import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Ui.css';
import { decodeToken } from '../api/common';

import NotificationBell from '../components/common/NotificationBell';

function Navbar({ onToggle, onSearch }) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const handleLogout = async () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('session');
    try {
      const res = await fetch('/api/auth/authentik/logout');
      const { logoutUrl } = await res.json();
      if (logoutUrl && new URL(logoutUrl).searchParams.has('id_token_hint')) {
        window.location.href = logoutUrl;
        return;
      }
    } catch (_) {}
    navigate('/login');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      onSearch(searchTerm); // ✅ 부모(Layout)로 검색어 전달
    }
  };
  const handleUserInfo = () => {
    const token = sessionStorage.getItem('token');
    if (token) {
      const payload = decodeToken(token);
      if (payload?.id) {
        navigate(`/users/${payload.id}`); // ✅ 현재 사용자 조회 화면으로 이동
      } else {
        alert('사용자 정보를 확인할 수 없습니다.');
      }
    } else {
      navigate('/login');
    }
  };

  return (
    <nav className="topbar d-flex align-items-center justify-content-between px-3 py-2 shadow-sm">
      {/* 좌측: 햄버거 버튼 + 검색창 */}
      <div className="d-flex align-items-center">
        <button className="btn btn-outline-secondary me-3" onClick={onToggle}>
          <i className="fas fa-bars"></i>
        </button>

        {/* 검색바 */}
        <form className="app-search d-none d-md-block" onSubmit={handleSearch}>
          <div className="search-box position-relative">
            <input
              type="search"
              className="form-control rounded-pill shadow-sm ps-4"
              placeholder="🔍 사용자 검색..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button type="submit" className="search-icon-btn">
              <i className="bx bx-search-alt"></i>
            </button>
          </div>
        </form>

      </div>

      {/* 우측: 알림 + 조직도 + 로그아웃 버튼 */}
      <div className="d-flex align-items-center">
        <NotificationBell />
        <button
          className="btn btn-outline-success me-2"
          onClick={handleUserInfo}
          title="내 정보"
        >
          <i className="fas fa-user"></i>
        </button>
        <button
          className="btn btn-outline-secondary me-2"
          onClick={() => navigate('/ai/gemin')}
          title="AI 채팅"
        >
          <i className="fas fa-robot"></i>
        </button>
        <button
          className="btn btn-outline-primary me-2"
          onClick={() => navigate('/orgchart')}
          title="조직도"
        >
          <i className="fas fa-sitemap"></i>
        </button>
        <button
          className="btn btn-outline-danger"
          onClick={handleLogout}
          title="로그아웃"
        >
          <i className="fas fa-sign-out-alt"></i>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;